import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Description, HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class LocationReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('LocationReference', httpService);
  }

  getForWarehouse(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForWarehouse/${id}`);
  }

  getDescription(id: string): Observable<Description[]> {
    return this.httpService.get<Description[]>(`${this.apiUrl}/GetDescription/${id}`);
  }
}
